import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import ReferralStatus from './Content';
import Details from './Details';

class Panel extends React.Component {
  constructor (props) {
    super(props);
    this.header = createRef(null);
    this.callIcon = createRef(null);
    this.emailIcon = createRef(null);
    this.textIcon = createRef(null);
    this.blue = createRef(null);
    this.red = createRef(null);
  }

  static propTypes = {
    opportunities: PropTypes.array,
    userprofile: PropTypes.object,
    activeReferral: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      leadSources: PropTypes.array,
      isRegisteredOnWebsite: PropTypes.bool
    }),
    activeAppointment: PropTypes.object,
    activeOpportunity: PropTypes.object
  };

  state = {
    buttonText: 'CONTACT DETAILS'
  }

  onClickContactDetailsToggle = () => {
    if (this.state.buttonText === 'CONTACT DETAILS') {
      this.setState({
        buttonText: 'FLIP'
      });
    } else {
      this.setState({
        buttonText: 'CONTACT DETAILS'
      });
    }
  }

  render () {
    const { firstName, lastName, leadSources } = this.props.activeReferral;
    const showDetails = this.state.buttonText === 'CONTACT DETAILS';
    return (
      <div>

        <div
          id='contact-details-header-panel'
          className={'card card-block top-card-wrap flip-transition '.concat(showDetails ? '' : 'card-flip')}
        >
          <div className='profile-header-name'>
            <div className={'profile-container '.concat(showDetails ? '' : 'card-back')}>
              <div className='d-flex'>
                <div className={'text-profile-update '.concat(showDetails ? 'text-profile-name' : 'text-profile-details')}>
                  {`${firstName} ${lastName}`}
                </div>
                <i
                  className={'font-size-20 icon referral-header-icon '.concat(showDetails ? 'icon-info' : 'icon-close')}
                  aria-hidden='true'
                  onClick={(e) => this.onClickContactDetailsToggle()}
                />
              </div>
              {showDetails &&
                <div className='text-truncate'>
                  <small className='text-muted'>
                    {`Source: ${leadSources && leadSources.length > 0 && leadSources[0] && leadSources[0].leadSource}`}
                  </small>
                </div>
              }
            </div>
          </div>

          {
            <div className='d-flex justify-content-evenly'>
              {
                showDetails
                  ? <ReferralStatus {...this.props} />
                  : <Details activeReferral={this.props.activeReferral} />
              }
            </div>

          }
        </div>
      </div>
    );
  }
}

export default Panel;
